/** Query keys de métricas (compartidas entre pantallas = un solo fetch). */
export const metricsKeys = {
  all: ['metrics'] as const,

  ownerDashboard: (year: number, month: number) =>
    [...metricsKeys.all, 'owner-dashboard', year, month] as const,

  ownerDashboardPair: (
    year: number,
    month: number,
    range?: { fromMonth: number; toMonth: number }
  ) =>
    range
      ? ([...metricsKeys.all, 'owner-dashboard-pair', year, 'r', range.fromMonth, range.toMonth] as const)
      : ([...metricsKeys.all, 'owner-dashboard-pair', year, month] as const),

  ownerPvpRetention: (year: number, month: number, months: number) =>
    [...metricsKeys.all, 'owner-pvp-retention', year, month, months] as const,

  ownerInsights: (year: number, month: number, months: number) =>
    [...metricsKeys.all, 'owner-insights', year, month, months] as const,

  clinicsComparison: (year: number, month: number) =>
    [...metricsKeys.all, 'clinics-comparison', year, month] as const,

  summary: (
    tenantId: string,
    year: number,
    month: number,
    consultorioId?: number,
    range?: { fromMonth: number; toMonth: number }
  ) =>
    range
      ? ([
          ...metricsKeys.all,
          'summary',
          tenantId,
          year,
          'r',
          range.fromMonth,
          range.toMonth,
          consultorioId ?? 'all',
        ] as const)
      : ([...metricsKeys.all, 'summary', tenantId, year, month, consultorioId ?? 'all'] as const),

  cajaReporte: (tenantId: string, year: number, month: number, consultorioId?: number) =>
    [...metricsKeys.all, 'caja-reporte', tenantId, year, month, consultorioId ?? 'all'] as const,

  cajaMovimientos: (
    tenantId: string,
    year: number,
    month: number,
    consultorioId?: number,
    tipo?: string,
    limit?: number
  ) =>
    [
      ...metricsKeys.all,
      'caja-movimientos',
      tenantId,
      year,
      month,
      consultorioId ?? 'all',
      tipo ?? 'all',
      limit ?? 'default',
    ] as const,

  monthlyTrend: (
    tenantId: string,
    year: number,
    month: number,
    months: number,
    consultorioId?: number
  ) =>
    [...metricsKeys.all, 'trend', tenantId, year, month, months, consultorioId ?? 'all'] as const,

  planRanking: (tenantId: string, year: number, month: number, months: number) =>
    [...metricsKeys.all, 'plan-ranking', tenantId, year, month, months] as const,

  sedes: (tenantId: string) => [...metricsKeys.all, 'sedes', tenantId] as const,

  planBilling: (tenantId: string, year: number, month: number) =>
    [...metricsKeys.all, 'plan-billing', tenantId, year, month] as const,

  billingVsRevenue: (tenantId: string, year: number, month: number) =>
    [...metricsKeys.all, 'billing-vs-revenue', tenantId, year, month] as const,

  subscriptionRisk: (year: number, month: number, tenantIds: string[]) =>
    [...metricsKeys.all, 'subscription-risk', year, month, ...tenantIds] as const,
};
